/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



//////////////////
// WEBPACK FOOTER
// ./~/cheerio/~/lodash/_realNames.js
// module id = 650
// module chunks = 0